import React from "react";
import { Clock, Truck, CheckCircle, XCircle } from "lucide-react";
import type { TabType, TabData } from "./types";

interface TrackingTabsProps {
  activeTab: TabType;
  setActiveTab: (tab: TabType) => void;
  tabsData: TabData[];
}

const TrackingTabs: React.FC<TrackingTabsProps> = ({
  activeTab,
  setActiveTab,
  tabsData,
}) => {
  const getTabIcon = (tab: string) => {
    switch (tab) {
      case "active":
        return <Clock className="w-5 h-5" />;
      case "shipped":
        return <Truck className="w-5 h-5" />;
      case "delivered":
        return <CheckCircle className="w-5 h-5" />;
      case "cancelled":
        return <XCircle className="w-5 h-5" />;
      default:
        return <Clock className="w-5 h-5" />;
    }
  };

  return (
    <div className="border-b border-section-border bg-section-card-bg">
      <div className="flex overflow-x-auto scrollbar-hide">
        {tabsData.map((tab) => {
          const isActive = activeTab === tab.key;
          return (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`flex items-center gap-3 px-6 py-4 text-sm font-medium border-b-2 transition-all whitespace-nowrap ${
                isActive
                  ? "text-primary border-primary bg-primary/5"
                  : "text-section-muted border-transparent hover:text-section-text hover:bg-section-surface"
              }`}
            >
              {getTabIcon(tab.key)}
              <span>{tab.label}</span>
              <span
                className={`px-2.5 py-0.5 text-xs font-semibold rounded-full ${
                  isActive
                    ? "bg-primary text-primary-foreground"
                    : "bg-section-surface text-section-muted"
                }`}
              >
                {tab.count}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TrackingTabs;
